import api from '@/services/api'
import { getOptionsString } from '@/services/api/helpers'
import { getNetworkSummaryDownloadUrl } from '@/services/api/analytics.helpers.js'

const getOrgPodcasts = (options) => {
  let optionsString = getOptionsString(options)
  let path = `/podcasts?${optionsString}`

  return api.get(path).then(async ({data}) => {
    return data
  })
}

const getNetworkSummary = (options) => {
  const path = getNetworkSummaryDownloadUrl(options)
  return api.get(path).then(async ({ data }) => {
    return data
  })
}

export default {
  getOrgPodcasts,
  getNetworkSummary
}
